import { QueryHookOptions, QueryResult, useQuery } from '@apollo/client';
import listUserPreferences from '../../graphql/listUserPreferences';
import { createClient } from '../../../../../src/services/client';

export interface UserPreference {
  id: string;
  type: string;
  enabled: boolean;
  // false = opted-in but awaiting DE double opt-in confirmation. Nullable for
  // backward compatibility (absent when the DOI feature is off). LPB-1506.
  confirmed?: boolean | null;
}

export interface ListUserPreferencesData {
  listUserPreferences: UserPreference[];
}

const useListUserPreferences = (
  options?: QueryHookOptions<ListUserPreferencesData>,
): QueryResult<ListUserPreferencesData> =>
  useQuery<ListUserPreferencesData>(listUserPreferences, { ...options, client: createClient });

export default useListUserPreferences;
